// todo:

import { UserHandleDto } from '../types/dtos/user-handle'
import { UserSuggestionModel } from '../types/models/user-suggestion'
import { findThumbnail } from '../utils/photo'

export const transformUserSuggestion = (user: UserHandleDto): UserSuggestionModel => {
  const { id, login, photo } = user

  return {
    id,
    login,
    thumbnail: findThumbnail(photo),
  }
}

export const transformUserSuggestions = (users: Array<UserHandleDto>): Array<UserSuggestionModel> =>
  users.map(transformUserSuggestion)
